module.exports = __webpack_public_path__ + "img/night-sweats.c9cd00db.svg";